import LTR from "@brand-icons/global/pin-event/pin-event-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinEventIcon = iconFactory("PinEventIcon", LTR);
